import React from 'react'
import "./ourApps.scss"

//Imagens:
import ImgOurApps from "../../../assets/reports/ourApps.png"
import { useTranslation } from 'react-i18next'

function OurApps() {
    const {t} = useTranslation()

    return (
        <div className='container-our-apps'>
            <div className='title-our-apps'>
                <h1>{t("reports.our_apps.title")}</h1>
            </div>
            <div className='our-apps-mob'>
                <div className='img-our-apps'>
                    <img src={ImgOurApps} alt="" />
                </div>
                <div className='texts-our-apps'>
                    <ol>
                        <li>{t("reports.our_apps.functionalities_list.dashboards_text")}</li>
                        <li>{t("reports.our_apps.functionalities_list.filter_text")}</li>
                        <li>{t("reports.our_apps.functionalities_list.export_pdf_text")}</li>
                        <li>{t("reports.our_apps.functionalities_list.send_email_text")}</li>
                        <li>AirPlay (iOS)</li>
                        <li>{t("reports.our_apps.functionalities_list.notifications_text")}</li>
                    </ol>
                    <br />
                    <p>{t("reports.our_apps.section_text")}</p>

                </div>
            </div>
        </div>
    )
}

export default OurApps